<template>
  <div class="metrics-summary-cards">
    <metrics-summary-card
      v-if="isOrgAdminView"
      icon="users-group"
      :label="$t('metrics.totalTeachers')"
      :value="summary.teachers || 0"
      :clickable="true"
      @click="$emit('view-teachers')"
    />
    <metrics-summary-card
      icon="graduation-cap-classes"
      :label="$t('metrics.totalClasses')"
      :value="summary.classes"
    />
    <metrics-summary-card
      icon="assignment-document"
      :label="$t('metrics.totalAssignments')"
      :value="summary.assignments"
    />
    <metrics-summary-card
      icon="class-group"
      :label="$t('metrics.totalStudents')"
      :value="summary.students"
    />
    <metrics-summary-card
      v-if="timeSaved"
      icon="clock"
      :label="$t('metrics.timeSaved')"
      :display-value="timeSaved"
    />
  </div>
</template>

<script>
import MetricsSummaryCard from "./metrics_summary_card.vue";

export default {
  name: "MetricsSummaryCards",

  components: {
    MetricsSummaryCard,
  },

  props: {
    summary: {
      type: Object,
      required: true,
    },
    isOrgAdminView: {
      type: Boolean,
      default: false,
    },
    timeSaved: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.metrics-summary-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 1024px) {
    gap: 12px;
  }
}
</style>
